<div class="bp-modal mod-lg wrapper">
	<bp-modal-header [title]="'send_via' | translate: [selectedCryptocoin?.name, selectedNetwork?.name]">
		<a (click)="onBackButtonClick()" (keydown.enter)="onBackButtonClick()" left>
			{{ "back" | translate }}
		</a>
		<a (click)="onCancelButtonClick()" (keydown.enter)="onCancelButtonClick()" right>
			{{ "cancel" | translate }}
		</a>
	</bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-body-section">
			<div class="bp-modal-description">
				<div class="header">
					@if (chooseClientStepActive) {
						<h2>{{ "address_book_send_on_behalf_toolbar_title" | translate }}</h2>
						<span class="title-description">
							{{ "add_client_details" | translate }}
						</span>
					} @else {
						<h2>{{ "address_book_send_on_behalf_title" | translate }}</h2>
						<span class="title-description">
							{{ "company_or_person_disclosure" | translate }}
							<a [href]="learnMoreUrl" target="_blank" class="learn-more-link">
								{{ "more_information" | translate }}
							</a>
						</span>
					}
				</div>
			</div>
		</div>
		<div class="bp-modal-body-section">
			@if (chooseClientStepActive) {
				<div class="wallet-owner">
					<label for="walletOwner">
						{{ "new_address_book_full_legal_name" | translate }}
					</label>
					<input
						type="text"
						id="walletOwner"
						[(ngModel)]="onBehalfOf"
						class="form-field mb-10"
						[placeholder]="'new_address_book_full_legal_name' | translate" />
					<span class="field-hint">{{ "new_address_book_full_legal_name_helper" | translate }}</span>
				</div>
				<button
					[disabled]="!onBehalfOf"
					(click)="save()"
					class="btn btn-primary btn-lg mod-button-width button-next"
					type="button">
					{{ "address_book_next" | translate }}
				</button>
			} @else {
				<div class="recipient-options">
					<div
						class="recipient-option"
						(click)="selectBusiness()"
						[tabIndex]="0"
						(keydown.enter)="selectBusiness()">
						<div class="option-icon">
							<svg-inline src="assets/images/icons/person.svg" alt="" />
						</div>
						<div class="option-content">
							<h3 class="option-title">{{
								"address_book_send_on_behalf_my_business_title" | translate
							}}</h3>
							<p class="option-description">
								{{ "sending_my_company_funds" | translate }}
							</p>
						</div>
						<div class="option-arrow">
							<span class="bpi__icon-caret-right"></span>
						</div>
					</div>

					<div
						class="recipient-option"
						(click)="selectClient()"
						[tabIndex]="0"
						(keydown.enter)="selectClient()">
						<div class="option-icon">
							<svg-inline src="assets/images/icons/persons.svg" alt="" />
						</div>
						<div class="option-content">
							<h3 class="option-title">{{
								"address_book_send_on_behalf_my_client_title" | translate
							}}</h3>
							<p class="option-description">
								{{ "sending_client_funds" | translate }}
							</p>
						</div>
						<div class="option-arrow">
							<span class="bpi__icon-caret-right"></span>
						</div>
					</div>
				</div>
			}
		</div>
	</div>
</div>
